// resources/js/woocommerce/card/index.js
import { mount as mountVariationPrice } from './variationPrice.js';

export function mount() {
  try { mountVariationPrice?.(); } catch (e) { console.error('[wk-card] mount', e); }
}

// Als deze module rechtstreeks geladen wordt (zonder app.js):
if (!window.__WK_CARD_BOOTED__) {
  window.__WK_CARD_BOOTED__ = true;
  // wacht tot DOM + jQuery klaar staan
  document.addEventListener('DOMContentLoaded', () => {
    if (window.jQuery) mount();
    else {
      // heel zelden kan jQuery later komen; probeer nog een keer
      const t = setInterval(() => {
        if (window.jQuery) { clearInterval(t); mount(); }
      }, 50);
      setTimeout(() => clearInterval(t), 2000);
    }
  });
}
